import dayjs from 'dayjs';

export const formatTime = (date: string) => {
  return dayjs.utc(date).format('HH:mm');
};
